import { artistRepsUrl } from '../urls';
import refresh from '../refresh';

export async function getArtistReps() {
  return refresh(async () => {
    const response = await fetch(artistRepsUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}

export async function getArtistRep(repId) {
  return refresh(async () => {
    const response = await fetch(`${artistRepsUrl}?${new URLSearchParams({
      rep: repId,
    })}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
